import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import Dashboard from "../layout/dashboard";

const Index = () => {
  const navigate = useNavigate();
  const [cookies] = useCookies();

  useEffect(() => {
    if (cookies["token"]) {
      navigate("/v2/home");
    } else {
      navigate("/auth/login");
    }
  }, []);

  return <Dashboard />;
};

export default Index;
